import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import Footer from "./Footer";
import ContentWrapper from "./ContentWrapper";

interface PrivateLayoutProps {
  children: React.ReactNode;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;

    if (collapsed) {
      root.classList.add('layout-menu-collapsed');
      root.classList.remove('layout-menu-expanded');
    } else {
      root.classList.remove('layout-menu-collapsed');
    }
  }, [collapsed]);

  useEffect(() => {
    const root = document.documentElement;

    if (root.clientWidth < 1200) {
      setCollapsed(true)
    }
  }, [location.key]);

  const handleCollapse = useCallback((collapse: boolean) => {
    const root = document.documentElement;

    if (root.clientWidth < 1200) {
      if (collapse) {
        root.classList.remove('layout-menu-expanded');
        root.classList.add('layout-menu-collapsed');
      } else {
        root.classList.add('layout-menu-expanded');
      }
    }

    setCollapsed(collapse)
  }, [collapsed])

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar collapsed={collapsed} onCollapse={handleCollapse} />
        <div className="layout-page">
          <Topbar collapsed={collapsed} onCollapse={handleCollapse} />
          <ContentWrapper>
            {children}
          </ContentWrapper>
          <Footer />
          <div className="content-backdrop fade"></div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default PrivateLayout;
